"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactMeasure = _interopRequireDefault(require("react-measure"));

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _calicoUiKit = require("@calico/calico-ui-kit");

var _ref2 = _react.default.createElement("a", {
  className: "calico-title block normal smooth nowrap",
  href: "https://www.calicolabs.com"
}, _react.default.createElement("strong", null, "Calico"), " research");

var _ref3 = _react.default.createElement("a", {
  href: "https://www.calicolabs.com"
}, _react.default.createElement(_calicoUiKit.CalicoLogo, {
  className: "calico-logo"
}));

var CalicoResearchHeader =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CalicoResearchHeader, _React$Component);

  function CalicoResearchHeader() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CalicoResearchHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CalicoResearchHeader)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleMeasureElement = function (rect) {
      var onMeasureElement = _this.props.onMeasureElement;

      if ((0, _lodash.isFunction)(onMeasureElement)) {
        onMeasureElement(rect);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(CalicoResearchHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style;
      var _this$props2 = this.props,
          showSubheader = _this$props2.showSubheader,
          subheader = _this$props2.subheader;
      var size = 37;
      var fadeInStyle = {
        opacity: 1,
        transition: 'opacity 0.35s'
      };
      var fadeOutStyle = {
        opacity: 0,
        transition: 'opacity 0.35s 0.2s'
      };
      return _react.default.createElement(_reactMeasure.default, {
        bounds: true,
        client: true,
        onResize: function onResize(contentRect) {
          return _this2.handleMeasureElement(contentRect);
        },
        scroll: true
      }, function (_ref) {
        var measureRef = _ref.measureRef;
        return _react.default.createElement("header", {
          className: (0, _classnames.default)('calico-research-header', className),
          ref: measureRef,
          style: (0, _extends2.default)({
            top: 0,
            zIndex: 101
          }, style)
        }, subheader && _react.default.createElement("div", {
          className: "subheader content-width smooth nowrap",
          style: showSubheader ? fadeInStyle : fadeOutStyle
        }, subheader), _ref2, _ref3);
      });
    }
  }]);
  return CalicoResearchHeader;
}(_react.default.Component);

CalicoResearchHeader.defaultProps = {
  onMeasureElement: null,
  showSubheader: false,
  subheader: null
};
var _default = CalicoResearchHeader;
exports.default = _default;